import _defineProperty from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { clsx, cssClass } from "../../core/index.js";
import { cssPrefix } from "./utils.js";
import { ThumbnailsTrack } from "./ThumbnailsTrack.js";
import { defaultThumbnailsProps } from "./Thumbnails.js";
export var ThumbnailsComponent = function ThumbnailsComponent(_ref) {
  var thumbnailsProps = _ref.thumbnails,
      slides = _ref.slides,
      index = _ref.index,
      carousel = _ref.carousel,
      animation = _ref.animation,
      render = _ref.render,
      styles = _ref.styles,
      children = _ref.children;

  var thumbnails = _objectSpread(_objectSpread({}, defaultThumbnailsProps), thumbnailsProps);

  var ref = React.useRef(null);
  var track = React.createElement(ThumbnailsTrack, {
    container: ref,
    slides: slides,
    thumbnails: thumbnails,
    carousel: carousel,
    animation: animation,
    render: render,
    startingIndex: index,
    thumbnailRect: {
      width: thumbnails.width,
      height: thumbnails.height
    },
    styles: styles
  });
  return React.createElement("div", {
    ref: ref,
    className: clsx(cssClass(cssPrefix()), cssClass(cssPrefix("".concat(thumbnails.position))))
  }, (thumbnails.position === "start" || thumbnails.position === "top") && track, React.createElement("div", {
    className: cssClass(cssPrefix("wrapper"))
  }, children), (thumbnails.position === "end" || thumbnails.position === "bottom") && track);
};